// extracted by mini-css-extract-plugin
module.exports = {"accentColor":"#FF6B08","greyColor":"rgba(24, 28, 39, 0.6)","blackColor":"#181C27"};